import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "menu", "user", "button", "secretOption", "replacedBySecretOption" ]

  showSecretOptions(event) {
    if(event.which == 18) {
      this.secretOptionTarget.classList.add('visible')
      this.replacedBySecretOptionTarget.style.display = 'none'
    }
  }

  hideSecretOptions(event) {
    if(event.which == 18) {
      this.secretOptionTarget.classList.remove('visible')
      this.replacedBySecretOptionTarget.style.display = 'block'
    }
  }

  toggle() {
    this.menuTarget.classList.toggle("open")
    this.userTarget.classList.toggle("active")
    this.syncExpanded()
  }

  keepOpen(event) {
    event.stopPropagation()
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.remove("open")
      this.userTarget.classList.remove("active")
      this.syncExpanded()
    }
  }

  syncExpanded() {
    if (!this.hasButtonTarget) return

    this.buttonTarget.setAttribute("aria-expanded", this.menuTarget.classList.contains("open"))
  }
}
